import { Link } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNewPasswordRequired from 'src/modules/iam/hooks/useNewPasswordRequired'
import { useIamStore } from '../../apis/store'

const LoginFormForgotPassword: React.FC = () => {
  const { send } = useIamStore((store) => ({ send: store.sendEvent }))
  const { sendRecoverPasswordEmail } = useNewPasswordRequired()
  const [t] = useTranslation()

  const handleClick = () => {
    sendRecoverPasswordEmail()
    send({ type: 'FORGOT_PASSWORD' })
  }

  return (
    <>
      <Link
        color='primaryColors.400'
        fontSize={['16px']}
        alignSelf='start'
        textDecoration='underline'
        fontWeight='400'
        data-testid={'link-forgot-pwd'}
        onClick={handleClick}
      >
        {t('login.Forgot my password')}
      </Link>
    </>
  )
}

export default LoginFormForgotPassword
